import { http, URL } from "./http.service";
import { errorHandler } from "./error.service";
export const getPitaraProducts = async () => {
  try {
    const result = await http.get(`${URL}/pitara`);
    return result;

  } catch (error) {
    return errorHandler(error);
  }
};

// const response = await http.post(
//   URL + `/uploadretailRocket/upload`)
// return response